<template>
	<v-app class="main">
		<a-header v-if="hasHeader" :step="headerStep" :type="header" />
		<div v-show="hasHeader" />
		<v-content class="main__content">
			<router-view @setHeader="headerStep = $event" />
			<a-footer v-if="!$route.meta.hideFooter" />
			<cookie-dialog v-if="!isPrivacyPage" />
		</v-content>
	</v-app>
</template>

<script>
import RouterNavigation from "@/mixins/RouterNavigation";
import AHeader from "@/components/Header";
import { NO_HEADER, STEPPER_HEADER, EMPTY_HEADER } from "@/headerType";
import AFooter from "@/components/Footer";
import CookieDialog from "@/components/CookieDialog";
import cssVars from "css-vars-ponyfill";
import i18n from "@/plugins/i18n";
import { mapGetters } from "vuex";

export default {
	name: "App",
	components: {
		AHeader,
		AFooter,
		CookieDialog
	},
	mixins: [RouterNavigation],
	data() {
		return {
			headerStep: -1
		};
	},
	computed: {
		hasHeader() {
			return this.header !== NO_HEADER;
		},
		header() {
			return this.getCurrentRouteMeta("header") || NO_HEADER;
		},
		showStepper() {
			return !this.getCurrentRouteMeta("hideStepper");
		},
		hasSteps() {
			return this.header === STEPPER_HEADER;
		},
		isPrivacyPage() {
			return this.$route.name === "privacy";
		},
		...mapGetters(["theme", "messages"])
	},
	watch: {
		hasSteps(val) {
			if (!val) {
				this.headerStep = -1;
			}
		},
		theme(newTheme) {
			cssVars({
				variables: {
					"primary-color": newTheme.primaryColor,
					"secondary-color": newTheme.secondaryColor
				}
			});
			this.$vuetify.theme.primary = newTheme.primaryColor;
			this.$vuetify.theme.secondary = newTheme.secondaryColor;
			this.$vuetify.theme.accent = newTheme.secondaryColor;
		},
		messages(newMessages) {
			for (const [lang, langMessages] of Object.entries(newMessages)) {
				i18n.mergeLocaleMessage(lang, langMessages);
			}
		}
	},
};
</script>

<style lang="scss">
html,
body {
	overflow: auto !important;

	/* Default text styles */
	font-size: 15px;
	line-height: 1.5;
	color: $black;
}

.main {
	background: $white !important;
	font-family: Verdana, sans-serif !important;
}

.main__content {
	position: relative;
}

.v-content__wrap {
	display: flex;
	flex-direction: column;
	justify-content: space-between;
}

.v-list {
	font-size: 15px !important;
	font-family: Verdana, sans-serif;
}

/* Headings */
h1,
h2,
h3,
h4 {
	font-family: TheSansOsF, sans-serif;
	font-weight: 600;
}

h1 {
	font-size: 36px;
	margin-bottom: 10px;
	color: var(--secondary-color);
	line-height: 1.2;
}

h2 {
	font-size: 24px;
	margin-bottom: 15px;
	color: var(--primary-color);
}

h3 {
	font-size: 18px;
	margin-bottom: 20px;
	line-height: 1.39;
	color: $black;
}

h4 {
	font-size: 14px;
	margin-bottom: 10px;
	color: var(--primary-color);
}

.tertiary {
	color: var(--tertiary-color);
}

li {
	margin-bottom: 16px;
}

@media only screen and (max-width: $mobile-breakpoint) {
	h1 {
		font-size: 30px;
	}
	h2 {
		font-size: 20px;
	}
	h3 {
		font-size: 16px;
	}
}
</style>
